module.exports = __webpack_public_path__ + "img/left-feather.728b3acb.svg";